import React, { PropsWithChildren } from 'react';

import styles from './Subtitle.module.scss';

interface SubtitleProps extends PropsWithChildren {}

const Subtitle: React.FC<SubtitleProps> = ({ children }) => {
  return <div className={styles.title}>{children}</div>;
};

export default Subtitle;
